<template>
	<div class="smains">
	<div class="bg-imgs">
		<div id="mains"></div>
		<div class="boardNav">
			<div style="width: 25%;height: 100%;float: left;">
				<div style="margin: 0px 80px 0 50px;">
					<div class="boardNavBg"></div>
				</div>
			</div>
			<div style="width: 55%;height: 100%;float: left;">
				<div class="boardNav_title" v-for="(list,index) in titleName">
					<div style="width: 100%;height: 100%;" @click="titleclick(list.title,index)">{{list.title}}</div>
				</div>
			</div>
			<div style="width: 20%;height: 100%;float: left;">
				<div class="boardNav_right">{{showDate}}
				<!--<el-button type='warning' size='mini' @click='chaxun()'>下单</el-button>-->
				</div>
			</div>
		</div>
		<div class="sales_title">
			<div style="height: 100%;width: 300px;">
				<div class="sales_bg"></div>
				<div style="height: 50px;width: 100%;margin-top: 10px;margin-left: 20px;color: #9AFAF3;">
					<div class="sales_boxes" @click="xsl()">
						<div class="sales_icon el-icon-check"></div><span class="sales_name" >销售量</span>
					</div>
					<div class="sales_boxes" @click="xsbs()">
						<div class="sales_icon "></div><span class="sales_name">销售笔数</span>
					</div>
				</div>
			</div>
		</div>
		<div class="sales_box" id="sales_boxone">
			<div class="sales_content">
				<div class="sales_content-bg"><span class="sales_imgone"></span></div>
				<div style="height: 65px;width: 100%;">
					<p class="roling">{{ljjye}}</p>
				</div>

			</div>
			<div class="sales_content">
				<div class="sales_content-bg"><span class="sales_imgtwo"></span></div>
				<div style="height: 65px;width: 100%;">
					<p class="roling" style="color: #A1FFF7;font-size: 50px;">{{jrzjye}}</p>
				</div>
			</div>
			<div class="sales_content">
				<div class="sales_content-bg"><span class="sales_imgthree"></span></div>
				<div style="height: 65px;width: 100%;">
					<p class="roling" style="color: #A1FFF7;font-size: 30px;">{{jrxsjye}}</p>
				</div>
			</div>
		</div>
		<div class="sales_box" id="sales_boxtwo" style="display: none;">
			<div class="sales_content">
				<div class="sales_content-bg2"><span class="sales_imgfour"></span></div>
				<div style="height: 65px;width: 100%;">
					<p class="roling">{{ljjyeNum}}</p>
				</div>

			</div>
			<div class="sales_content">
				<div class="sales_content-bg2"><span class="sales_imgfive"></span></div>
				<div style="height: 65px;width: 100%;">
					<p class="roling" style="color: #A1FFF7;font-size: 50px;">{{jrzjyeNum}}</p>
				</div>
			</div>
			<div class="sales_content">
				<div class="sales_content-bg2"><span class="sales_imgsix"></span></div>
				<div style="height: 65px;width: 100%;">
					<p class="roling" style="color: #A1FFF7;font-size: 30px;">{{jrxsjyeNum}}</p>
				</div>
			</div>
		</div>
		<div class="paymethod">
			<div style="padding: 25px 0px 0px 60px">
				<div class="pay_title"></div>
			</div>
			<div class="turnover">
				<div class="pay_method" v-for="(list,index) in paymethodName">
					<div style="width: 100%;height: 100%;" @click="payDetails(list.name,index)">{{list.name}}</div>
				</div>
			</div>
			<div class="turnover_table"  id="payDetails" style="display: none;">
				<table class="middle-table">
		    		<tr>
		    			<th>支付方式</th>
		    			<th>支付宝</th>
		    			<th>微信</th>
		    			<th>银联</th>
		    			<th>取货码</th>
		    			<th>会员卡</th>
		    			<th>现金</th>
		    			<th>其他</th>
		    		</tr>
		    		<tr v-for="lists in turnoverData">
		    			<td>{{lists.classify}}</td>
		    			<td>{{lists.alipaysl}}</td>
		    			<td>{{lists.wxpaysl}}</td>
		    			<td>{{lists.unionpaysl}}</td>
		    			<td>{{lists.pickcodesl}}</td>
		    			<td>{{lists.memberpaysl}}</td>
		    			<td>{{lists.cashsl}}</td>
		    			<td>{{lists.othersl}}</td>
		    		</tr>
		    </table>
			</div>
			<div class="turnover_table" id="payRanking" style="display: block">
				<div style="height: 30px;;line-height: 30px;margin-left: 35px;" v-for="list in rankData">
					<div class="turnover-setting">{{list.name}}</div>
					<div style="height: 30px;width: 180px;float: left;padding-top: 12px;margin-right: 10px;">
						<el-progress :percentage="list.percent" :color="list.colors" :show-text="false"></el-progress>
					</div>
					<div class="turnover-setting">{{list.value}}</div>
				</div>
			</div>
			<div  id="pie" style="display: none;"></div>
		</div>
	</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { Message } from "element-ui";
import request from "@/utils/request";
import echarts from "echarts";
// import '../../../node_modules/_echarts@4.1.0@echarts/map/js/china.js';
//import '../../../node_modules/_echarts@4.2.0-rc.1@echarts/map/js/china.js';
//import '../../../node_modules/_echarts@4.2.0-rc.2@echarts/map/js/china.js';


export default {
    name: "xfmx",
    data() {
        return {
        	userId:'',
        	titleName:[{
        		title:'销售大数据',
        		value:0
        	},{
        		title:'生产大数据',
        		value:1
        	},{
        		title:'售后大数据',
        		value:2
        	},{
        		title:'商户大数据',
        		value:3
        	},{
        		title:'商品大数据',
        		value:4
        	},{
        		title:'客户大数据',
        		value:5
        	}],
        	paymethodName:[{
        		name:'支付方式详情',
        		value:0
        	},{
        		name:'支付方式排名',
        		value:1
        	},{
        		name:'支付方式交易占比',
        		value:2
        	}],
        	ljjye:0,
        	jrzjye:0,
        	jrxsjye:0,
        	ljjyeNum:0,
        	jrzjyeNum:0,
        	jrxsjyeNum:0,
        	turnoverData:[{
        		classify:'销售量',
        		alipaysl:0,
        		wxpaysl:0,
        		unionpaysl:0,
        		pickcodesl:0,
        		memberpaysl:0,
        		cashsl:0,
        		othersl:0,
        	}],
        	showDate:'',
        	rankData:[],
        	pieData:[],
        	regionData:[],
        	coordinateData:{},
        	tempArrOne:[],
        	tempArrTwo:[],
        	lastOrderTime:null,
        	curOrdertime:null,
        }
    },
    created: function () {
    	this.getUserid();
    	this.initWebSocket();
    	this.onloadpage();
    },
    mounted:function(){
    	this.nowTimes();
  		this.initchartForjs();
  		this.initPie();
        this.timer = setInterval(this.getDetailTime, 1000);
        var pieTimer=setInterval(this.initPie,60*1000)
 	},
    beforeDestroy () {
        if(this.timer) {
            clearInterval(this.timer);//在vue实例销毁钱，清除我们的定时器
        };
        if(this.pieTimer) {
            clearInterval(this.pieTimer);
        }
    },
    methods: {
    	/*aa(){
    		var order={orderid:'1122',position:[120.13,33.38]};
    		var map = {};
            map[order.orderid] = order.position;
            map['北京'] = 'gfsdfg';
            console.log(map);
    	},*/
    	xsl(){
    		document.getElementById("sales_boxone").style.display='block';
    		document.getElementById("sales_boxtwo").style.display='none';
    		document.getElementsByClassName("sales_icon")[0].classList.add("el-icon-check");
    		document.getElementsByClassName("sales_icon")[1].classList.remove("el-icon-check");
    	},
    	xsbs(){
    		document.getElementById("sales_boxone").style.display='none';
    		document.getElementById("sales_boxtwo").style.display='block';
    		document.getElementsByClassName("sales_icon")[0].classList.remove("el-icon-check");
    		document.getElementsByClassName("sales_icon")[1].classList.add("el-icon-check");
    	},
    	getUserid(){
    		var d = new Date().getTime();
			var	uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var	r = (d + Math.random()*16)%16 | 0;
			d = Math.floor(d/16);
			  return (c=='x'? r : (r&0x3|0x8)).toString(16);
			});
			this.userId=uuid;
    	},
    	getDetailTime(){
    		let datelocalweek=new Array("星期日", "星期一", "星期二","星期三","星期四", "星期五","星期六");
	      	let year = new Date(new Date()).getFullYear();
	      	let month =new Date(new Date()).getMonth() + 1 < 10? "0" + (new Date(new Date()).getMonth() + 1): new Date(new Date()).getMonth() + 1;
	      	let date =new Date(new Date()).getDate() < 10? "0" + new Date(new Date()).getDate(): new Date(new Date()).getDate();
	      	let hh =new Date(new Date()).getHours() < 10? "0" + new Date(new Date()).getHours(): new Date(new Date()).getHours();
	      	let mm =new Date(new Date()).getMinutes() < 10? "0" + new Date(new Date()).getMinutes(): new Date(new Date()).getMinutes();
	      	let ss =new Date(new Date()).getSeconds() < 10? "0" + new Date(new Date()).getSeconds(): new Date(new Date()).getSeconds();
	      	let datelocalweekday=datelocalweek[new Date(new Date()).getDay()];
            this.showDate = year + "-" + month + "-" + date +" "+" "+hh+":"+mm+":"+ss+" "+datelocalweekday;
    	},
    	onloadpage(){
    		var registerData={
    			userId:this.userId,
    			type:0,
    		}
    		request({url:'service-order/register/doRegisterClient',method:'post',data:registerData})
	    		.then(response => {
	    			console.log(response);
	    		})
	    		.catch(error => {
	    			Message.error('error:请检查网络是否连接')
	    		})
    	},
    	titleclick(titles,index){//tab标题切换
    		for(var i=0;i<this.titleName.length;i++){
    			if(i == index){
    				document.getElementsByClassName('boardNav_title')[i].style.color='#fff';
    			}else{
    				document.getElementsByClassName('boardNav_title')[i].style.color='#7DBBD4';
    			}
    		};
    		var registerData={
    			userId:this.userId,
    			type:index,
    		}
    		request({url:'service-order/register/doRegisterClient',method:'post',data:registerData})
	    		.then(response => {
	    			console.log(response);
	    		})
	    		.catch(error => {
	    			Message.error('error:请检查网络是否连接')
	    		})
    	},
	    initWebSocket: function () {
	   		//var wsurl= "ws://175.6.4.138:6014/ws/message/"+this.userId+""; //测试环境
			var wsurl= "ws://175.6.72.228:8093/ws/message/"+this.userId+"";//生产环境
		    //this.websock = new WebSocket('ws://192.168.1.28:8082/saiyi/websocket');
		    this.websock = new WebSocket(wsurl);
	        this.websock.onopen = this.websocketonOpen;
	        this.websock.onerror = this.websocketonerror;
	        this.websock.onmessage = this.websocketonmessage;
	        this.websock.onclose = this.websocketonclose;
	    },
	    websocketonOpen: function () {
	        console.log("WebSocket连接成功");
	    },
	    websocketonerror: function (e) {
	        console.log("WebSocket连接发生错误");
	    },
	    websocketonmessage: function (e) {
	    	var that=this;
	   	    console.log(e);
	      	//销售量数据
	      	var r_data = null;
	      	if(e.data){
	      		if(e.data == "已建立连接!"){
	      			return;
	      		}
	      		r_data=eval('('+e.data+')');
	      	};
	      	if(r_data == null){
	      		return;
	      	}
	      	if(r_data.todaytransactionsSum){
	      		if(this.jrzjye ===0){
	      			that.jrzjye = r_data.todaytransactionsSum;
	      		}else{
	      			let time = 2000/(r_data.todaytransactionsSum - this.jrzjye);
	      			let interval = setInterval(function() {
          				if(that.jrzjye+1>r_data.todaytransactionsSum){
          					that.jrzjye = r_data.todaytransactionsSum;
          					clearInterval(interval);
          				}else{
          					that.jrzjye++;
          				}
        			}, time);
        		}
	      	};
	      	if(r_data.todaytransactionsOnLine){
	      		if(this.jrxsjye ===0){
	      			that.jrxsjye = r_data.todaytransactionsOnLine;
	      		}else{
	      			let time = 2000/(r_data.todaytransactionsOnLine - this.jrxsjye);
	      			let interval = setInterval(function() {
          				if(that.jrxsjye+1>r_data.todaytransactionsOnLine){
          					that.jrxsjye = r_data.todaytransactionsOnLine;
          					clearInterval(interval);
          				}else{
          					that.jrxsjye++;
          				}
        			}, time);
        		}
	      	};
	      	if(r_data.allTransactionSum){
	      		if(this.ljjye ===0){
	      			that.ljjye = r_data.allTransactionSum;
	      		}else{
	      			let time = 2000/(r_data.allTransactionSum - this.ljjye);
	      			let interval = setInterval(function() {
          				if(that.ljjye+1>r_data.allTransactionSum){
          					that.ljjye = r_data.allTransactionSum;
          					clearInterval(interval);
          				}else{
          					that.ljjye++;
          				}
        			}, time);
        		}
	      	};
	      	//销售笔数数据
	      	if(r_data.todaytransactionsNumberSum){
	      		if(this.jrzjyeNum ===0){
	      			that.jrzjyeNum = r_data.todaytransactionsNumberSum;
	      		}else{
	      			let time = 2000/(r_data.todaytransactionsNumberSum - this.jrzjyeNum);
	      			let interval = setInterval(function() {
          				if(that.jrzjyeNum+1>r_data.todaytransactionsNumberSum){
          					that.jrzjyeNum = r_data.todaytransactionsNumberSum;
          					clearInterval(interval);
          				}else{
          					that.jrzjyeNum++;
          				}
        			}, time);
        		}
	      	};
	      	if(r_data.todaytransactionsNumberOnLine){
	      		if(this.jrxsjyeNum ===0){
	      			that.jrxsjyeNum = r_data.todaytransactionsNumberOnLine;
	      		}else{
	      			let time = 2000/(r_data.todaytransactionsNumberOnLine - this.jrxsjyeNum);
	      			let interval = setInterval(function() {
          				if(that.jrxsjyeNum+1>r_data.todaytransactionsNumberOnLine){
          					that.jrxsjyeNum = r_data.todaytransactionsNumberOnLine;
          					clearInterval(interval);
          				}else{
          					that.jrxsjyeNum++;
          				}
        			}, time);
        		}
	      	};
	      	if(r_data.allTransactionsNumberSum){
	      		if(this.ljjyeNum ===0){
	      			that.ljjyeNum = r_data.allTransactionsNumberSum;
	      		}else{
	      			let time = 2000/(r_data.allTransactionsNumberSum - this.ljjyeNum);
	      			let interval = setInterval(function() {
          				if(that.ljjyeNum+1>r_data.allTransactionsNumberSum){
          					that.ljjyeNum = r_data.allTransactionsNumberSum;
          					clearInterval(interval);
          				}else{
          					that.ljjyeNum++;
          				}
        			}, time);
        		}
	      	};
	      	/*地图数据*/
	      	if(r_data.tag == 'two'){
	      		this.tempArrTwo=[];
			   	this.tempArrOne.unshift({
			   		name:r_data.productName,
			   		value:eval("("+r_data.value+")")
			   	});
			   	if(this.tempArrOne.length<80){
			   		this.tempArrTwo=this.tempArrOne;
			   	}
			   	if(this.tempArrOne.length>=80){
			   		for(var i=0;i<80;i++){
		      			this.tempArrTwo.push(this.tempArrOne[i])
		     	};
			   	}
			   	for(var i=0;i<this.tempArrTwo.length;i++){
			   		if(this.tempArrTwo[i].value.length == 3){
			   			this.tempArrTwo[i].value.push(i);
			   		}else{
			   			this.tempArrTwo[i].value[3]=i;
			   		}

			   	}
			   	this.regionData=this.tempArrTwo;
	      		this.initchartForjs();
	      	}
	    },
	    websocketonclose: function (e) {
	    	console.log(e);
	    },

	    nowTimes(){
	        document.getElementsByClassName('boardNav_title')[0].style.color='#fff';
	        document.getElementsByClassName('pay_method')[1].style.color='#0BC2E2';
	        document.getElementsByClassName('pay_method')[1].style.borderBottom='1px solid #0BC2E2';
	    },
	    payDetails(titles,index){
	    	for(var i=0;i<this.paymethodName.length;i++){
    			if(i == index){
    				document.getElementsByClassName('pay_method')[i].style.color='#0BC2E2';
	      			document.getElementsByClassName('pay_method')[i].style.borderBottom='1px solid #0BC2E2';
    			}else{
    				document.getElementsByClassName('pay_method')[i].style.color='#A6BDE9';
    				document.getElementsByClassName('pay_method')[i].style.borderBottom='none';
    			}
    		};
    		if(titles == '支付方式详情'){
    			document.getElementById("payDetails").style.display='block';
	    		document.getElementById("payRanking").style.display='none';
	    		document.getElementById("pie").style.display='none';
    		}else if(titles == '支付方式排名'){
    			document.getElementById("payDetails").style.display='none';
	    		document.getElementById("payRanking").style.display='block';
	    		document.getElementById("pie").style.display='none';
    		}else if(titles == '支付方式交易占比'){
    			document.getElementById("payDetails").style.display='none';
	    		document.getElementById("payRanking").style.display='none';
	    		document.getElementById("pie").style.display='block';
    		}
	    },
    	initchartForjs:function(){
	        let myChart = this.$echarts.init(document.getElementById('mains'));
	        /*var geoCoordMap = this.coordinateData;
			var data =this.regionData;*/
			/*var regionData =[
			            	{name:'上海',value:[121.48,31.22,"http://www.xynetweb.com:8086/sysFile/defaultgoods.png"]},
			            	{name:'抚顺',value:[123.97,41.97,"http://www.xynetweb.com:8086/sysFile/defaultgoods.png"]}
			            ];*/
	        // 绘制图表
	        myChart.setOption({
			    title: {
			        text: '',
			        textStyle: {
			            color: '#000'
			        }
			    },
			    animation: false,
			    tooltip: {
			        trigger: 'item',
			        formatter: function (params) {
			            return params.name +'<div style="height: 30px;width: 30px;">'+'<img src='+params.value[2]+' style="display: block;height: 30px;width: 30px;"/></div>';
			        }

			    },
			    grid: {
				    top:30,
			    	bottom:200,
			    	left:40,
			    	right:40
				},
			    geo: {
			        map: 'china',
			        label: {
			        	normal: {
			                    show: true,
			                    textStyle:{color:"rgba(125,187,282,0.8)",fontSize:12}
			                },
			            emphasis: {
			                show: true
			            }
			        },
			        itemStyle: {
			            normal: {
			                areaColor: '#4447D1',
			                borderColor: 'rgba(255,255,255,0.15)'
			            },
			            emphasis: {
			                areaColor: '#4447D1'
			            }
			        }
			    },
			    series: [
			        {
			            name: '',
			            type: 'scatter',
			            coordinateSystem: 'geo',
			            data: this.regionData,
			            symbolSize: 5,
			            color:'#0DE0FD',
			            label: {

			                normal: {
			                    show: false
			                },
			                emphasis: {
			                    show: false
			                }
			            },
			            itemStyle: {
			                emphasis: {
			                    borderColor: '#fff',
			                    borderWidth: 1
			                }
			            }
			        },
			        {
			            name: '',
			            type: 'effectScatter',
			            coordinateSystem: 'geo',
			            data:this.regionData,
			            //symbol: 'image://http://www.xynetweb.com:8086/sysFile/defaultgoods.png',
			            symbolSize: function (val) {
			            	if(val[3] == 0){
			            		return 20;
			            	}else{
			            		return 10
			            	}

			            },
			            showEffectOn: 'render',
			            rippleEffect: {
			                brushType: 'stroke'
			            },
			            hoverAnimation: true,
			            label: {
			                normal: {
			                    formatter: '{b}',
			                    position: 'right',
			                    show: false
			                }
			            },
			            itemStyle: {
			                normal: {
			                    color: '#0DE0FD',
			                    shadowBlur: 20,
			                    shadowColor: '#333'
			                }
			            },
			            zlevel: 1
			        }
			    ]
	        });
	        window.addEventListener("resize", function () {
		        myChart.resize();
		    });
			myChart.dispatchAction({
				type: 'showTip',
				seriesIndex: 0,
				dataIndex: 0
			});
			setTimeout(function(){
				myChart.dispatchAction({
					type: 'hideTip',
					seriesIndex: 0,
					dataIndex: 0
				});
			}, 5000);
  		},
	  	initPie(){//支付方式交易额中的三个图表：支付方式详情、排名占比
	  		request({url:'service-order/salesBigData/doGetTradeStatisticsOfToday',method:'post',data:{}})
	  			.then(response => {
	  				response.data[0].classify='销售量(笔)';
	  				this.turnoverData=response.data;
	  				var percentArry=[response.data[0].alipaysl,response.data[0].wxpaysl,response.data[0].unionpaysl,
	  				response.data[0].pickcodesl,response.data[0].memberpaysl,response.data[0].cashsl,response.data[0].othersl];
	  				var percentageArr=[];
	  				for(var i=0;i<percentArry.length;i++){
	  					percentageArr.push((percentArry[i]/response.data[0].allCount)*100)
	  				}
	  				this.tempData=[];
	  				this.tempData.push({
	  					name:'支付宝',
		        		percent:percentageArr[0],
		        		colors:'#00A0EE',
		        		value:response.data[0].alipaysl,
	  				},{
	  					name:'微信',
		        		percent:percentageArr[1],
		        		colors:'#0FD11B',
		        		value:response.data[0].wxpaysl,
	  				},{
	  					name:'银联',
		        		percent:percentageArr[2],
		        		colors:'#008089',
		        		value:response.data[0].unionpaysl,
	  				},{
	  					name:'提货码',
		        		percent:percentageArr[3],
		        		colors:'#C626E3',
		        		value:response.data[0].pickcodesl,
	  				},{
	  					name:'会员卡',
		        		percent:percentageArr[4],
		        		colors:'#EBD9A4',
		        		value:response.data[0].memberpaysl,
	  				},{
	  					name:'现金',
		        		percent:percentageArr[5],
		        		colors:'#CC953E',
		        		value:response.data[0].cashsl,
	  				},{
	  					name:'其他',
		        		percent:percentageArr[6],
		        		colors:'#FF6600',
		        		value:response.data[0].othersl,
	  				});
	  				var compareVal = function (obj1, obj2) {
					    var val1 = obj1.value;
					    var val2 = obj2.value;
					    if (val1 > val2) {
					        return -1;
					    } else if (val1 < val2) {
					        return 1;
					    } else {
					        return 0;
					    }
					}
	  				this.rankData=this.tempData.sort(compareVal);
	  				var temppieData=new Array();
	  				for(var i=0;i<this.tempData.length;i++){
	  					if(this.tempData[i].value !== 0){
	  						temppieData.push(this.tempData[i])
	  					}
	  				}
	  				let myChart = this.$echarts.init(document.getElementById('pie'));
	  			 	myChart.setOption({
				    	tooltip : {
					        trigger: 'item',
					        formatter: "{a} <br/>{b} : {c} ({d}%)"
					    },
					    color:['#00A0EE','#0FD11B','#008089','#C626E3','#EBD9A4','#CC953E','#FF6600'],
					    series : [
					        {
					            name: '详细数据',
					            type: 'pie',
					            radius: ['30%', '40%'],
			            		avoidLabelOverlap: false,
			            		itemStyle: {
			                normal: {label:{
			            		show:true,
			            		formatter:'{b} : {c} ({d}%)',
			            	},
			            	labelLine:{show:true}},
			                emphasis: {
			                    label: {
			                        show: true,
			                        formatter: "{b}\n{c} ({d}%)",
			                        position: 'center',
			                        textStyle: {
			                            fontSize: '14',
			                            fontWeight: 'bold'
			                        }
			                    }
			                }
			            },
				            data:temppieData
				        }
				    ]
		       });
	  			}).catch(error =>{
	  				Message.error('error:请检查网络是否连接');
	  			})

	  	},
	  	chaxun(){
	      	request({ url: 'service-order/producer/doSendMessage', method: 'post', data:{} })
	        .then(response => {
	        }).catch(error => {
	      	})

		},
  	},
};
</script>

<style scoped>
.smains {
	height: 100%;
	width: 100%;
	overflow: hidden;
}
.bg-imgs {
	height: 100%;
	width: 100%;
	overflow: hidden;
	position: fixed;
	background: url(img/bg.png);
	background-size:cover;
}
#mains{
	height: 100%;
	width: 100%;
}
.boardNav{
	height: 100px;
	width: 100%;
	margin-top: 40px;
	overflow: hidden;
	position: absolute;
	top: 0;
}
.boardNavBg{
	height: 25px;
	width: 100%;
	background: url(img/dsj.png) no-repeat;
	background-size:100% 100% ;
}
.boardNav_title{
	width: 16%;
	height:100%;
	float: left;
	text-align: right;
	font-size: 18px;
	color: #7DBBD4;
	font-weight: bold;
	padding-top: 5px;
}
.boardNav_title:hover{
	cursor: pointer;
}
.boardNav_choosed{
	color: #fff;
}
.boardNav_right{
	height: 100%;
	padding-right: 20px;
	text-align: right;
	padding-top: 8px;
	font-size: 16px;
	font-weight: bold;
	color: #fff;
	font-family:Arial, Helvetica, sans-serif;
}
.sales_title{
	width: 100%;
	height: 150px;
	overflow: hidden;
	position: absolute;
	top: 150px;
	padding-left: 50px;
}
.sales_bg{
	height: 70px;
	width: 200px;
	background: url(img/xsfsj.png)no-repeat;
	background-size:100% 100% ;
}
.sales_boxes{
	overflow: hidden;
	float: left;
}
.sales_icon{
	height: 20px;
	width: 20px;
	border: 2px solid #9AFAF3;
	border-radius: 2px;
	color:#5598B7;
	float: left;
}
.sales_name{
	padding: 0 30px 0 10px;
	font-size: 16px;
	font-weight: bold;
	display: block;
	float: left;
}
.sales_box{
	width: 470px;
	overflow: hidden;
	position: absolute;
	top: 300px;
}
.sales_content{
	height: 130px;
	width: 100%;
	margin-bottom: 6px;
	background: rgba(5,38,101,0.8);
}
.sales_content-bg{
	padding: 25px 0px 0px 35px;
}
.sales_content-bg2{
	padding: 25px 0px 0px 35px;
}
.sales_content-bg>span{
	display: block;
	height: 40px;
	width: 215px;
}
.sales_content-bg2>span{
	display: block;
	height: 40px;
	width: 280px;
}
.sales_content-bg>.sales_imgone{
	background: url(img/ljjye.png) no-repeat;
	background-size:100% 100% ;
}
.sales_content-bg>.sales_imgtwo{
	background: url(img/zjye.png) no-repeat;
	background-size:100% 100% ;
}
.sales_content-bg>.sales_imgthree{
	background: url(img/xszf.png) no-repeat;
	background-size:100% 100% ;
}
.sales_content-bg2>.sales_imgfour{
	background: url(img/ljjybs.png) no-repeat;
	background-size:100% 100% ;
}
.sales_content-bg2>.sales_imgfive{
	background: url(img/zjybs.png) no-repeat;
	background-size:100% 100% ;
}
.sales_content-bg2>.sales_imgsix{
	background: url(img/xszfbs.png) no-repeat;
	background-size:100% 100% ;
}
.roling{
	margin: 0;
	width: 100%;
	height: 65px;
	text-align: center;
	line-height: 65px;
	color: #FFAC75;
	font-size: 32px;
	animation: myMove 5s linear infinite;
    animation-fill-mode: forwards;
}
.paymethod{
	width: 385px;
	height: 365px;
	background: rgba(5,38,101,0.8);
	position: absolute;
	top: 300px;
	right: 0;
}
.pay_title{
	height: 40px;
	width: 210px;
	background: url(img/zffsjye.png) no-repeat;
	background-size:100% 100% ;
}
.turnover{
	height: 35px;
	width: 100%;
	padding-left: 60px;
	margin: 20px 0;
}
.pay_method{
	height: 45px;
	width: 60px;
	font-size: 14px;
	margin-right:25px;
	color: #A6BDE9;
	font-weight: bold;
	line-height: 20px;
	text-align: center;
	float: left;
}
.pay_method:hover{
	cursor: pointer;
}
.turnover_table{
	margin: 25px 25px 0;
}
.middle-table{
	height: 68px;
	width: 100%;
	border-collapse:collapse;
	font-family:Arial, Helvetica, sans-serif;
}
.middle-table th{
	border-top: 1px solid #0D316B;
	border-bottom: 1px solid #0D316B;
	color: #fff;
	font-size: 12px;
	text-align: center;
}
.middle-table td{
	border-bottom: 1px solid #0D316B;
	font-size: 12px;
	color: #fff;
	font-weight: bold;
	text-align: center;
}
.turnover-setting{
	height: 30px;
	width: 50px;
	float: left;
	font-size: 12px;
	color: rgba(255,255,255,0.8);
	font-weight: 600;
}
#pie{
	height: 220px;
	width: 385px;
}
</style>



// WEBPACK FOOTER //
// src/views/databases/databases.vue